'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alert = require('./alert.html');

var _alert2 = _interopRequireDefault(_alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _alert2.default,
  bindings: {
    alerts: '<',
    onAlertClicked: '&'
  },
  controller: function () {
    function AlertComponent($state, AuthService, EventEmitter) {
      'ngInject';

      _classCallCheck(this, AlertComponent);

      Object.assign(this, { $state: $state, AuthService: AuthService, EventEmitter: EventEmitter });
    }

    _createClass(AlertComponent, [{
      key: 'alertClicked',
      value: function alertClicked(alert) {
        this.onAlertClicked(this.EventEmitter({
          alert: alert
        }));
      }
    }]);

    return AlertComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/common/alert/alert.component.js